module["exports"] = [
  "### ###-####",
  "1 ### ###-####",
  "### ###-####, poste ###"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/fr_CA/phone_number/formats.js
// module id = 1359
// module chunks = 1